import { PageBase } from '../page/page.base';
import { IPublicPageBase } from './public-page.interface';

export abstract class PublicPageBase extends PageBase implements IPublicPageBase { 

}